import { useState } from 'react';
import { Camera, X } from 'lucide-react';
import { Badge } from './ui/badge';
import { Dialog, DialogContent } from './ui/dialog';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_serpent-safe/artifacts/c5hlozmd_snake.png',
      title: 'Cobra Rescue in Forest',
      span: 'md:col-span-2 md:row-span-2',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_serpent-safe/artifacts/arrjinuj_snake2.png',
      title: 'Rat Snake Handling',
      span: 'md:col-span-1 md:row-span-1',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_serpent-safe/artifacts/r8rfpqp6_snake3.png',
      title: 'Cobra Rescue Indoors',
      span: 'md:col-span-1 md:row-span-1',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_serpent-safe/artifacts/f92fc7ag_snake4.png',
      title: 'Snake Relocation',
      span: 'md:col-span-1 md:row-span-2',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_serpent-safe/artifacts/ke8464b6_snake5.png',
      title: 'Cobra with Hood Display',
      span: 'md:col-span-2 md:row-span-1',
    },
  ];

  return (
    <section 
      id="gallery"
      className="py-20 md:py-32 bg-[#EAE7DF]"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge variant="outline" className="mb-4 text-[#2A4B35] border-[#2A4B35]">
            <Camera className="w-3 h-3 mr-1" />
            Rescue Gallery
          </Badge>
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1D1A] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="gallery-heading"
          >
            Snake Rescue Operations in Bangalore
          </h2>
          <p className="text-[#4A4D4A] text-lg max-w-2xl mx-auto">
            Real photos from our <strong>snake removal</strong> and rescue operations across Bangalore
          </p>
        </div>

        {/* Tetris Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6 auto-rows-[200px] md:auto-rows-[180px]">
          {galleryImages.map((image, index) => (
            <div 
              key={index}
              className={`gallery-item relative rounded-2xl overflow-hidden cursor-pointer group ${image.span}`}
              onClick={() => setSelectedImage(image)}
              data-testid={`gallery-image-${index + 1}`}
            >
              <img 
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {image.title}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Image Dialog */}
        <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
          <DialogContent className="max-w-4xl p-0 bg-black border-none overflow-hidden">
            {selectedImage && (
              <div className="relative">
                <button 
                  onClick={() => setSelectedImage(null)}
                  className="absolute top-4 right-4 z-10 bg-white/20 hover:bg-white/30 p-2 rounded-full transition-colors"
                  data-testid="gallery-dialog-close"
                >
                  <X className="w-5 h-5 text-white" />
                </button>
                <img 
                  src={selectedImage.url}
                  alt={selectedImage.title}
                  className="w-full h-auto max-h-[80vh] object-contain"
                />
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
                  <p className="text-white text-xl font-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {selectedImage.title}
                  </p>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

export default Gallery;
